import React from "react";

const NextButton = props => (
  <svg className="cursor-pointer fill-current text-gray-300 hover:text-teal-500" width={13} height={20} {...props}>
    <path d="M11.82 11.462L3.865 19.42a1.882 1.882 0 0 1-2.652 0l-.664-.664a1.88 1.88 0 0 1 0-2.651l6.07-6.072L.549 3.96a1.88 1.88 0 0 1 0-2.65L1.21.644a1.88 1.88 0 0 1 2.652 0l7.957 7.957c.391.391.566.916.537 1.43a1.858 1.858 0 0 1-.536 1.43z" />
  </svg>
);

export default NextButton;
